import styled from 'styled-components';

const LabelText = styled.span`
  color: ${(p) => p.theme.primaryColor};
  font-weight: bold;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1px;
`;

export default LabelText;
